<template>
    <v-select
            outlined
            :items="states"
            label="State"
            :value="value"
            :error-messages="errorMesgFn"
            error-count=2
            :required="isRequired"
            @change="value = $event"
    >
    </v-select>
</template>

<script>
    import { UsStates } from '../../shared/enums/UsStates';

    export default {
        name: "UsStatesSelect",
        props:['errorFn', 'state', 'required'],
        data(){
            return{
                states: UsStates,
                value: ""
            }
        },
        computed:{
            errorMesgFn(){
                return this.errorFn;
            },
            isRequired(){
                return this.required;
            }
        },
        watch:{
            value(newValue){
                this.$emit('state-selected',newValue);
            },
            state:{
                immediate: true,
                handler(newState) {
                    this.value = newState;
                }
            }
        },
    }
</script>